import { type IReportSectionModel, ReportSectionTypeName } from 'tno-core';

export const createReportSection = (
  reportId: number,
  type: ReportSectionTypeName,
): IReportSectionModel => {
  return {
    id: 0,
    reportId,
    sectionType: type,
    name: crypto.randomUUID(),
    description: '',
    sortOrder: 0,
    isEnabled: true,
    chartTemplates: [],
    settings: {
      label: '',
      useAllContent: type === ReportSectionTypeName.MediaAnalytics,
      removeDuplicates: false,
      removeDuplicateTitles3Days: false,
      overrideExcludeHistorical: false,
      showHeadlines: type === ReportSectionTypeName.TableOfContents,
      showFullStory: type === ReportSectionTypeName.Content,
      showImage: type === ReportSectionTypeName.Gallery,
      hideEmpty: false,
      direction:
        type === ReportSectionTypeName.Gallery || type === ReportSectionTypeName.MediaAnalytics
          ? 'row'
          : 'column',
      groupBy: 'otherSource',
      sortBy: '',
      sortDirection: '',
      url: '',
      // New AI sections read the sections chosen for them; existing sections keep the whole report.
      aiScope: type === ReportSectionTypeName.AI ? 'Sections' : undefined,
      sourceSections: type === ReportSectionTypeName.AI ? [] : undefined,
    },
  };
};
